/** `DashboardIcon` → `dashboard`, `DeskIcon` → `desk` */
export function exportNameToIconName(exportName: string): string {
  const withoutSuffix = exportName.endsWith('Icon') ? exportName.slice(0, -4) : exportName;
  if (!withoutSuffix) {
    return exportName;
  }
  return withoutSuffix.charAt(0).toLowerCase() + withoutSuffix.slice(1);
}

export type ExportNameToIconName<T extends string> = T extends `${infer Base}Icon`
  ? Uncapitalize<Base>
  : Uncapitalize<T>;
